var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateTextEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5002 3.15503H12.9402C12.4002 3.15503 11.9202 2.81503 11.7502 2.30503L11.6602 2.03503C11.2802 0.915029 10.2402 0.155029 9.05023 0.155029H6.49023C4.97023 0.155029 3.74023 1.38503 3.74023 2.90503V10.905C3.74023 12.425 4.97023 13.655 6.49023 13.655H17.4902C19.0102 13.655 20.2402 12.425 20.2402 10.905V5.90503C20.2402 4.38503 19.0102 3.15503 17.4902 3.15503H17.5002ZM18.7502 10.905C18.7502 11.595 18.1902 12.155 17.5002 12.155H6.50023C5.81023 12.155 5.25023 11.595 5.25023 10.905V2.90503C5.25023 2.21503 5.81023 1.65503 6.50023 1.65503H9.06024C9.60023 1.65503 10.0802 1.99503 10.2502 2.50503L10.3402 2.77503C10.7202 3.89503 11.7602 4.65503 12.9502 4.65503H17.5102C18.2002 4.65503 18.7602 5.21503 18.7602 5.90503V10.905H18.7502Z",
    fill: "var(--color-color7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5 15.155H4.5C3.26 15.155 2.25 14.145 2.25 12.905V3.90503C2.25 3.49503 1.91 3.15503 1.5 3.15503C1.09 3.15503 0.75 3.49503 0.75 3.90503V12.905C0.75 14.975 2.43 16.655 4.5 16.655H16.5C16.91 16.655 17.25 16.315 17.25 15.905C17.25 15.495 16.91 15.155 16.5 15.155Z",
    fill: "#var(--color-color7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateTextEditorIcon);
export default __webpack_public_path__ + "static/media/template-text-editor-icon.5b743d863ecf8b4e3609722257fa11af.svg";
export { ForwardRef as ReactComponent };